const componentType = {
    general: 1,
    skype: 2,
    exchange: 3,
    sharePoint: 4
};

export default componentType;
